import { Alert, Button, Modal } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { WfsDataResponse } from "../../../types/Wfs/WfsResponse";

export interface DataResultViewProps {
  dataResponse: WfsDataResponse;
  onClose: () => void;
}

const DataResultView = ({
  dataResponse: { data, fileName },
  onClose,
}: DataResultViewProps) => {
  const navigate = useNavigate();

  const download = () => {
    const dataUrl = window.URL.createObjectURL(data);
    const tempLink = document.createElement("a");
    tempLink.href = dataUrl;
    tempLink.setAttribute("download", fileName);
    tempLink.click();
    navigate("/");
  };

  return (
    <>
      <Modal.Body>
        <Alert variant="success">Your data is ready!</Alert>
        <p>Download it below</p>
      </Modal.Body>
      <Modal.Footer>
        <Button className="bg-error" variant="error" onClick={onClose}>
          Close
        </Button>
        <Button variant="success" onClick={download}>
          Download Data
        </Button>
      </Modal.Footer>
    </>
  );
};

export default DataResultView;
